import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ResultEmpty, ResultServerAction, unwrapSettledResultSuccess } from '@headless-workspace/core-domain';
import useSWR from 'swr';
import { getFavoriteStoreServerAction, getSelectedStoreServerAction, StoreInfoValue } from '../../../../server';

type useSelectedStoreArgs = {
    productId?: string;
    onSuccess: ({
        selectedStore,
        favoriteStore,
    }: {
        selectedStore?: StoreInfoValue;
        favoriteStore?: StoreInfoValue;
    }) => void;
};

export const useSelectedStore = ({ productId, onSuccess }: useSelectedStoreArgs): { isLoading: boolean } => {
    const getStores = () =>
        Promise.allSettled([
            productId
                ? getSelectedStoreServerAction(productId)
                : Promise.reject(ResultServerAction(ResultEmpty(), ServerActionName.getSelectedStore)),
            getFavoriteStoreServerAction(),
        ]);

    const { isLoading } = useSWR(
        productId ? [CacheKeys.SelectedStore, productId, CacheKeys.FavoriteStore] : CacheKeys.FavoriteStore,
        getStores,
        {
            onSuccess: (results) => {
                onSuccess({
                    selectedStore: unwrapSettledResultSuccess(results[0]),
                    favoriteStore: unwrapSettledResultSuccess(results[1]),
                });
            },
        },
    );

    return { isLoading };
};
